/* Tres Vera — cart drawer controller.
   Opens/closes the drawer, handles AJAX add/update/remove via the
   Shopify Ajax Cart API, and triggers `cart:updated` so other UI
   (count badge, analytics) can react. */
(function () {
  const drawer = () => document.getElementById('tv-cart-drawer');
  const SECTION = 'tv-cart-drawer';
  const ANIM_MS = 360;
  let lastFocus = null;

  function dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail }));
  }

  function open() {
    const d = drawer();
    if (!d) return;
    lastFocus = document.activeElement;
    d.removeAttribute('hidden');
    requestAnimationFrame(() => d.setAttribute('data-open', 'true'));
    document.body.style.overflow = 'hidden';
    const closeBtn = d.querySelector('[data-tv-cart-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }
  function close() {
    const d = drawer();
    if (!d) return;
    d.removeAttribute('data-open');
    document.body.style.overflow = '';
    setTimeout(() => {
      d.setAttribute('hidden', '');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    }, ANIM_MS);
  }

  // Re-render the drawer body + footer from the cart section.
  async function refresh() {
    try {
      const res = await fetch(`${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'}?section_id=${SECTION}`);
      if (!res.ok) throw new Error('section fetch failed');
      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const incoming = tmp.querySelector('#tv-cart-drawer');
      const current = drawer();
      if (!incoming || !current) return;
      // Replace body + foot only; keep header + open state.
      const bodyNew = incoming.querySelector('[data-tv-cart-body]');
      const footNew = incoming.querySelector('[data-tv-cart-foot]');
      const bodyCur = current.querySelector('[data-tv-cart-body]');
      const footCur = current.querySelector('[data-tv-cart-foot]');
      if (bodyNew && bodyCur) bodyCur.replaceWith(bodyNew);
      if (footNew && footCur) footCur.replaceWith(footNew);
      // Update count badge in header.
      const cartRes = await fetch('/cart.js').then((r) => r.json()).catch(() => null);
      if (cartRes) {
        document.querySelectorAll('[data-tv-cart-count]').forEach((el) => {
          el.textContent = '(' + cartRes.item_count + ')';
        });
        const host = document.getElementById('cart-icon-bubble');
        const existing = host && host.querySelector('.cart-count');
        if (cartRes.item_count > 0) {
          if (existing) {
            existing.textContent = cartRes.item_count;
          } else if (host) {
            const span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = cartRes.item_count;
            host.appendChild(span);
          }
        } else if (existing) {
          existing.remove();
        }
        dispatch('cart:updated', cartRes);
      }
    } catch (e) {
      console.warn('[tv-cart] refresh failed', e);
    }
  }

  // --- AJAX add (from product card + product page) ---
  async function add(form) {
    const fd = new FormData(form);
    const res = await fetch(form.action || '/cart/add', {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw err;
    }
    return res.json();
  }

  async function update(line_key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line_key, quantity }),
    });
    return res.json();
  }

  // --- Event delegation ---
  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('[data-tv-cart-open]');
    if (openBtn) { e.preventDefault(); open(); return; }
    const closeBtn = e.target.closest('[data-tv-cart-close]');
    if (closeBtn) { e.preventDefault(); close(); return; }
    const remove = e.target.closest('[data-tv-cart-remove]');
    if (remove) {
      e.preventDefault();
      update(remove.dataset.lineKey, 0).then(refresh);
      return;
    }
    // Plus en min in de winkelmand. Het getal staat in een span, niet in een
    // invoerveld, dus we lezen het daar uit in plaats van uit een input.
    const step = e.target.closest('[data-tv-cart-step]');
    if (step) {
      e.preventDefault();
      if (step.disabled) return;
      const line = step.closest('[data-tv-cart-line]');
      if (!line) return;
      const veld = line.querySelector('.tvzcart-aantal');
      const nu = parseInt((veld && veld.textContent) || '1', 10) || 1;
      const nieuwAantal = nu + parseInt(step.dataset.tvCartStep, 10);
      if (nieuwAantal < 0) return;
      // Twee keer klikken voordat de eerste wijziging terug is, geeft een
      // verkeerd aantal. Daarom de knoppen even uit tot de winkelmand terug is.
      line.querySelectorAll('[data-tv-cart-step]').forEach((b) => { b.disabled = true; });
      update(step.dataset.lineKey, nieuwAantal).then(refresh);
      return;
    }
  });

  // Opmerking bij de bestelling. Opslaan zodra het veld de aandacht verliest,
  // niet bij elke toetsaanslag: dat zou een aanvraag per letter betekenen.
  document.addEventListener('focusout', (e) => {
    const note = e.target.closest('[data-tv-cart-note]');
    if (!note) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value }),
    }).catch(() => {});
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-tv-quick-add], [data-tv-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    if (btn) btn.disabled = true;
    add(form)
      .then((item) => {
        dispatch('cart:added', item);
        return refresh();
      })
      .then(() => {
        // On PDP, show 1.8s "Added to ritual" state then open drawer.
        if (form.matches('[data-tv-product-form]')) {
          const label = form.querySelector('[data-tv-add-label]');
          const added = form.querySelector('[data-tv-added-label]');
          if (label && added) {
            label.hidden = true;
            added.hidden = false;
            setTimeout(() => { label.hidden = false; added.hidden = true; }, 1800);
          }
        }
        open();
      })
      .catch((err) => {
        console.warn('[tv-cart] add failed', err);
        const msg = (err && err.description) || (window.tvT && window.tvT.cart_add_failed);
        if (msg) alert(msg);
      })
      .finally(() => { if (btn) btn.disabled = false; });
  });

  // Stepper changes inside the drawer → AJAX update.
  document.addEventListener('change', (e) => {
    const stepperInput = e.target.closest('[data-tv-cart-body] .tv-stepper__value');
    if (!stepperInput) return;
    const line = stepperInput.closest('[data-tv-cart-line]');
    if (!line) return;
    update(line.dataset.lineKey, parseInt(stepperInput.value, 10) || 0).then(refresh);
  });

  // Escape closes the drawer if it's open.
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const d = drawer();
      if (d && d.hasAttribute('data-open')) close();
    }
  });
})();
